// libs
import React, { useEffect } from 'react';
import cx from 'classnames';
// defs
import { NotificationTypeEnum, } from '@/stores/notification/defs';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// stores
import useNotificationsStore from '@/stores/notification';
// styles
import styles from './NotificationBar.module.scss';
import { IconBell } from '@/constants/icons/svg';
import { tokens } from '@swiggy-private/dls-web-common/dist/components';
import { CROSS } from '@/constants/icons/unicode';
const getNotificationProps = (type) => {
    switch (type) {
        case NotificationTypeEnum.ERROR:
            return {
                variant: DlsFontVariants.body_B1_Reg,
                color: DlsColorTokens.negative,
                className: styles.notificationError,
                bellColor: tokens.colors.red1,
            };
        case NotificationTypeEnum.SUCCESS:
            return {
                variant: DlsFontVariants.body_B1_Reg,
                color: DlsColorTokens.positive,
                className: styles.notificationSuccess,
                bellColor: tokens.colors.green1,
            };
        case NotificationTypeEnum.WARNING:
            return {
                variant: DlsFontVariants.body_B1_Reg,
                color: DlsColorTokens.text_Highest_Emphasis,
                className: styles.notificationWarning,
                bellColor: tokens.colors.orange1,
            };
        case NotificationTypeEnum.INFO:
        default:
            return {
                variant: DlsFontVariants.body_B1_Reg,
                color: DlsColorTokens.text_Highest_Emphasis,
                className: styles.notificationInfo,
                bellColor: tokens.colors.lavendar1,
            };
    }
};
const NotificationBar = ({ notifications, className, onClose }) => {
    if (!notifications || notifications.length === 0)
        return null;
    return (React.createElement("div", { className: cx(styles.container, className) }, notifications.map((notification) => {
        const { variant, color, className, bellColor } = getNotificationProps(notification.type);
        const handleCloseClick = () => {
            onClose(notification.id);
        };
        return (React.createElement("div", { key: notification.id, className: cx(styles.notificationContainer, className) },
            React.createElement("span", { className: styles.notificationContainerLeft },
                React.createElement(IconBell, { height: 24, width: 24, fillColor: bellColor }),
                React.createElement(Text, { variant: variant, color: color }, notification.message)),
            React.createElement("div", { role: "button", className: styles.notificationAction, onClick: handleCloseClick }, String.fromCharCode(CROSS))));
    })));
};
export default NotificationBar;
export const WithNotificationBar = (Component, className) => (props) => {
    const { notifications, clear, removeNotification } = useNotificationsStore();
    useEffect(() => clear, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(NotificationBar, { notifications: notifications, className: className, onClose: removeNotification }),
        React.createElement(Component, Object.assign({}, props))));
};
